export default __webpack_public_path__ + "static/media/IMG8786.90339c30.jpg";